import React from 'react'
import FacebookLogin from 'react-facebook-login'
import './Facebook.css'

class Facebook extends React.Component {
/*  isUserLoggedIn() {
    FB.getLoginStatus(function(response) {
      statusChangeCallback(response);
    });
  }

  createLoginButton() {
    <fb:login-button
      scope="public_profile,email"
      onlogin="checkLoginState();">
    </fb:login-button>
  }

  checkLoginState() {
    FB.getLoginStatus(function(response) {
      statusChangeCallback(response);
    });
  }
*/

  componentClicked(response) {
    console.log("componentClicked");
    console.log(response);
  }

  onCallbackFriends(something) {
    console.log("onCallbackFriends");
    console.log(something);
  }

  responseFacebook(response) {
    console.log("responseFacebook");
    console.log(response);
    // This should return a list of Facebook users who also use this App
    window.FB.api('/me/friends', this.onCallbackFriends); //(something) => { this.onCallbackFriendlists(something) });
  }

  render() {
    return (
      <div>
        <h1>Find your friends!</h1>
        <FacebookLogin
          appId="1640529749360400"
          autoLoad={false}
          fields="name,email,picture"
          icon="fa-facebook"
          textButton="Connect with Facebook"

          onClick={this.componentClicked}
          callback={(response) => {this.responseFacebook(response);}} />
      </div>
    );
    // I'm annoyed about the uppercase - WTF would you do that?  People could uppercase the text if they want.
    // cssClass="kep-login-facebook kep-login-facebook-medium"
    // TODO:  Figure it out later
  }
}

export default Facebook;



// WEBPACK FOOTER //
// ./src/containers/Facebook.js